export default __webpack_public_path__ + "static/sodclear-9c14a836daa840fa0a734ffbd64452b1.png";